export default "__VITE_ASSET__$xv8J5MN__"